let tourClusterer = null

function getClustererCtor() {
	if (window.markerClusterer && window.markerClusterer.MarkerClusterer) return window.markerClusterer.MarkerClusterer
	if (window.MarkerClusterer) return window.MarkerClusterer
	return null
}

window.initTourCluster = function (map, markerEntries, opts) {
	if (!map || !markerEntries || !markerEntries.length) return null

	const Ctor = getClustererCtor()
	if (!Ctor) return null

	const options = Object.assign({ maxZoom: 13 }, opts || {})

	if (tourClusterer) {
		tourClusterer.clearMarkers(true)
		tourClusterer.setMap(null)
		tourClusterer = null
	}

	const markerObjects = markerEntries.map((e) => e && e.marker).filter(Boolean)

	tourClusterer = new Ctor({
		map: map,
		markers: markerObjects,
		algorithmOptions: { maxZoom: Number(options.maxZoom) || 13 }
	})

	if (typeof tourClusterer.render === 'function') tourClusterer.render()

	return tourClusterer
}

window.renderTourCluster = function () {
	if (tourClusterer && typeof tourClusterer.render === 'function') tourClusterer.render()
}

window.clearTourCluster = function () {
	if (!tourClusterer) return
	tourClusterer.clearMarkers(true)
	tourClusterer.setMap(null)
	tourClusterer = null
}
